import { useEffect, useState } from "react";
import { API_URLS } from "../../apiUrl";
import axiosInstance from "../../components/axiosInstance";

function BoroughDropdown(muniCipalityId: any) {
  const [boroughList, setBoroughList] = useState<any>([]);
  const [loadingBoroughList, setLoadingBoroughList] = useState(false);
  const [isDropdownOpenBorough, setIsDropdownOpenBorough] = useState(false);

  const fetchBorough = async () => {
    if (loadingBoroughList) return;
    setLoadingBoroughList(true);

    try {
      const response = await axiosInstance.post(
        API_URLS.GetMunicipalityBorough,
        {
          municipalityTbl_id: muniCipalityId,
          page: 1,
          limit: 100000,
          surveyer_id: 0,
        }
      );

      const data = response.data;

      if (data?.data?.data) {
        setBoroughList(data.data.data);
      }
    } catch (error) {
      console.error("Error fetching Borough", error);
    } finally {
      setLoadingBoroughList(false);
    }
  };

  useEffect(() => {
    if (muniCipalityId) {
      setBoroughList([]);
      fetchBorough();
    }
  }, [muniCipalityId]);

  return [
    setIsDropdownOpenBorough,
    isDropdownOpenBorough,
    fetchBorough,
    boroughList,
    loadingBoroughList,
    setLoadingBoroughList,
  ];
}

export default BoroughDropdown;